module.exports = __webpack_public_path__ + "img/SooKlein.06a2db39.jpg";